import { useEffect } from 'react';

export type ToastType = 'success' | 'error' | 'info';

interface ToastProps {
  message: string;
  type?: ToastType;
  visible: boolean;
  onClose: () => void;
}

const iconMap: Record<ToastType, string> = {
  success: 'ri-checkbox-circle-fill',
  error: 'ri-error-warning-fill',
  info: 'ri-information-fill',
};

const colorMap: Record<ToastType, string> = {
  success: 'text-secondary-400',
  error: 'text-accent-400',
  info: 'text-primary-400',
};

export default function Toast({ message, type = 'info', visible, onClose }: ToastProps) {
  useEffect(() => {
    if (!visible) return undefined;
    const timer = window.setTimeout(onClose, 2600);
    return () => window.clearTimeout(timer);
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-[80] animate-fade-up">
      <div className="flex items-center gap-3 px-5 py-3 rounded-lg bg-background-800 border border-background-700 shadow-none">
        <i className={`${iconMap[type]} ${colorMap[type]} text-lg`}></i>
        <span className="text-sm text-foreground-100 whitespace-nowrap">{message}</span>
      </div>
    </div>
  );
}